import { Controller } from "stimulus";

// Drives the "Convidar para a sala" modal in the redesigned professor classroom.
// Real invites reuse the existing per-attendance notification endpoint
// (notify_online_attendance_path) carried on each checkbox's data-notify-url.
// WhatsApp / E-mail channel buttons are client-side share helpers built from the
// room link (no backend dependency).
export default class extends Controller {
  static targets = ["overlay", "item", "checkbox", "count", "send", "toast", "link"];

  open() {
    this.overlayTarget.style.display = "grid";
  }

  close() {
    this.overlayTarget.style.display = "none";
  }

  backdropClose(event) {
    if (event.target === this.overlayTarget) this.close();
  }

  onToggle(event) {
    const item = event.target.closest(".invite__item");
    if (item) item.classList.toggle("sel", event.target.checked);
    this.refreshState();
  }

  selectAll() {
    const allChecked = this.selectedCheckboxes.length === this.checkboxTargets.length;
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = !allChecked;
      const item = checkbox.closest(".invite__item");
      if (item) item.classList.toggle("sel", checkbox.checked);
    });
    this.refreshState();
  }

  refreshState() {
    const count = this.selectedCheckboxes.length;
    if (this.hasCountTarget) this.countTarget.textContent = count;
    if (this.hasSendTarget) this.sendTarget.disabled = count === 0;
  }

  get selectedCheckboxes() {
    return this.checkboxTargets.filter((checkbox) => checkbox.checked);
  }

  send() {
    const selected = this.selectedCheckboxes;
    if (selected.length === 0) return;

    Promise.allSettled(selected.map((checkbox) => this.notify(checkbox.dataset.notifyUrl)))
      .then(() => {
        this.close();
        this.showToast(selected.length === 1 ? "Convite enviado a 1 aluno" : `Convite enviado a ${selected.length} alunos`);
        this.checkboxTargets.forEach((checkbox) => {
          checkbox.checked = false;
          const item = checkbox.closest(".invite__item");
          if (item) item.classList.remove("sel");
        });
        this.refreshState();
      });
  }

  notify(url) {
    const token = document.querySelector('meta[name="csrf-token"]').content;
    return fetch(url, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "X-CSRF-Token": token,
        "X-Requested-With": "XMLHttpRequest",
        "Accept": "application/json"
      }
    });
  }

  whatsapp() {
    const text = encodeURIComponent(`Entre na sala de aula online: ${this.roomLink}`);
    window.open(`https://wa.me/?text=${text}`, "_blank");
  }

  email() {
    const subject = encodeURIComponent("Convite para a sala de aula online");
    const body = encodeURIComponent(`Entre na sala de aula online: ${this.roomLink}`);
    window.location.href = `mailto:?subject=${subject}&body=${body}`;
  }

  get roomLink() {
    return this.hasLinkTarget ? this.linkTarget.value : "";
  }

  showToast(message) {
    if (!this.hasToastTarget) return;

    this.toastTarget.textContent = message;
    this.toastTarget.style.display = "inline-flex";
    clearTimeout(this.toastTimeout);
    this.toastTimeout = setTimeout(() => {
      this.toastTarget.style.display = "none";
    }, 2400);
  }
}
